import PropTypes from "prop-types"
import React from "react"
import { TAX_TYPES } from "src/constants/taxTypes"

import Button from "src/components/Button"

import { formattedDecimalToTax } from "src/utils/UnitConversion"

const ProductTaxRow = ({ tax, onDelete }) => {
  // Get display label for tax type
  const getTaxTypeLabel = (taxType) => {
    const type = TAX_TYPES.find((t) => t.value === taxType)
    return type ? type.label : taxType
  }

  const taxTypeDisplay = tax.taxTypeDisplay || getTaxTypeLabel(tax.tax_type)
  const rateDisplay = tax.rateDisplay || formattedDecimalToTax(tax.rate)

  return (
    <div className="flex items-center justify-between py-2 text-sm">
      <div className="flex-1">
        <span className="font-medium">{tax.name}</span>
        <span className="mx-2 text-gray-400">•</span>
        <span className="text-gray-600">{taxTypeDisplay}</span>
        <span className="mx-2 text-gray-400">•</span>
        <span className="font-medium">{rateDisplay}</span>
      </div>
      <Button
        onClick={onDelete}
        icon="fa-sf-trashcan"
        iconOnly
        small
        variant="ghost-tertiary"
        title="Delete tax"
      />
    </div>
  )
}

ProductTaxRow.propTypes = {
  tax: PropTypes.shape({
    name: PropTypes.string.isRequired,
    tax_type: PropTypes.string.isRequired,
    taxTypeDisplay: PropTypes.string,
    rate: PropTypes.number.isRequired,
    rateDisplay: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default ProductTaxRow
